export default {};



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/form_validation/messages.js